var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUnauthorizedPerson(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 512,
    viewBox: "0 0 64 64",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Authorization_manager",
    "data-name": "Authorization manager"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m36.92 34.44-4.92 26.56h-12l-4.92-26.56c.19-.05.38-.11.57-.15l1.35-.29 4-1 5 3 5-3 4 1 1.35.29c.19.04.38.1.57.15z",
    fill: "#9bc9ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m35.389 34.084-5.389 26.916h2l4.92-26.56c-.19-.05-.38-.11-.57-.15z",
    fill: "#8cb5e5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m16.611 34.084 5.389 26.916h-2l-4.92-26.56c.19-.05.38-.11.57-.15z",
    fill: "#8cb5e5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m15.081 34.437a15.99 15.99 0 0 0 -12.081 15.498v11.065h17z",
    fill: "#58595b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m39 59v-16a2 2 0 0 1 2-2h1v-4.29a15.813 15.813 0 0 0 -5.082-2.27l-4.918 26.56h9a2 2 0 0 1 -2-2z",
    fill: "#58595b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m31 29.651a9.988 9.988 0 0 0 5-8.651v-4h-.078a4 4 0 0 1 -3.122-1.5l-2.8-3.5-1.6 2a8 8 0 0 1 -6.247 3h-6.153v4a9.988 9.988 0 0 0 5 8.651 9.941 9.941 0 0 0 10 0z",
    fill: "#ffbcab"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m28.503 39.999-.217-2.17-2.286-1.829-2.286 1.829-.217 2.17 2.503 1.001z",
    fill: "#cca400"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m26 41-2.503-1.001-1.497 15.001 4 4 4-4-1.497-15.001z",
    fill: "#ffcd00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m31 33v-3.349a9.941 9.941 0 0 1 -10 0v3.349l5 3z",
    fill: "#ff9478"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m31 40 4-6-4-1-5 3z",
    fill: "#2488ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m26 36-5-3-4 1 4 6z",
    fill: "#2488ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m28.4 14 1.6-2 2.8 3.5a4 4 0 0 0 3.122 1.5h2.078v-4a10 10 0 0 0 -10-10h-4a10 10 0 0 0 -10 10v4h8.155a8 8 0 0 0 6.245-3z",
    fill: "#ff9811"
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#d80027",
    height: 20,
    rx: 2,
    width: 22,
    x: 39,
    y: 41
  }), /*#__PURE__*/React.createElement("path", {
    d: "m45 41v-8a5 5 0 0 1 10 0v8h3v-8a8 8 0 0 0 -16 0v8z",
    fill: "#ff9811"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m40.7 60.97a1.954 1.954 0 0 0 .3.03h18a2.006 2.006 0 0 0 2-2v-16c0 9.746-9.019 17.65-20.3 17.97z",
    fill: "#c20023"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m13 48a1 1 0 0 1 1 1v12a0 0 0 0 1 0 0h-2a0 0 0 0 1 0 0v-12a1 1 0 0 1 1-1z",
    fill: "#414042"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m52 49a2 2 0 1 0 -3 1.723v6.277a1 1 0 0 0 2 0v-6.277a1.994 1.994 0 0 0 1-1.723z",
    fill: "#f1f2f2"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnauthorizedPerson);
export default __webpack_public_path__ + "static/media/unauthorized-person.dbc6ac687293caa11718a76a7bbc25a1.svg";
export { ForwardRef as ReactComponent };